export const LEAVE_TYPES = {
    'annual': { name: 'Annual Leave', color: 'bg-blue-500', abbreviation: 'AL' },
    'sick': { name: 'Sick Leave', color: 'bg-red-500', abbreviation: 'SL' },
    'no-pay': { name: 'Leave Without Pay', color: 'bg-gray-500', abbreviation: 'LWP' },
    'special': { name: 'Special Leave', color: 'bg-teal-500', abbreviation: 'SPL' },
    'compassionate': { name: 'Compassionate Leave', color: 'bg-yellow-500', abbreviation: 'CL' },
    'rdo': { name: 'Rostered Day Off', color: 'bg-purple-500', abbreviation: 'RDO' },
};

export const ROLES = ['employee', 'manager', 'payroll'];

export const LOGO_URL = 'https://www.billbergia.com.au/wp-content/uploads/2021/10/Billbergia-logo.png';

export const MonthMap = {
    January: "01",
    February: "02",
    March: "03",
    April: "04",
    May: "05",
    June: "06",
    July: "07",
    August: "08",
    September: "09",
    October: "10",
    November: "11",
    December: "12",
};